<template>
  <div class="main">
    <c-panel title="Assuntos" titleIcon="fas fa-tags">
      <!--
        Item 6: "cadastrar os assuntos dos exemplares, informando a descrição e o nível".
        O assunto pai é opcional — o edital pede nível, e a árvore é conveniência de quem
        quiser organizar.
      -->
      <catalogo-crud tipo="assunto" rotuloNovo="NOVO ASSUNTO" nomeSingular="assunto"
                     placeholderBusca="Pesquisar por descrição"
                     :campos="campos" :colunas="colunas"></catalogo-crud>
    </c-panel>
  </div>
</template>

<script>
import CatalogoCrud from '../catalogo/catalogo-crud.vue'

export default {
  components: { CatalogoCrud, cPanel: () => import('@/shared/c-panel/c-panel.vue') },
  data: () => ({
    campos: [
      { chave: 'descricao', label: 'Descrição', obrigatorio: true, span: 16, max: 191 },
      { chave: 'nivel', label: 'Nível', tipo: 'numero', obrigatorio: true, padrao: 1, span: 8 },
      { chave: 'assunto_pai_id', label: 'Assunto pai (opcional)', tipo: 'select', opcoesDe: 'assunto', span: 24 }
    ],
    colunas: [
      { chave: 'descricao', label: 'Descrição' },
      { chave: 'nivel', label: 'Nível', largura: '90px' }
    ]
  })
}
</script>
